import { STORE_KEYS } from 'configs/fetchApi';
import { getMobileNumber } from 'utils/methods';
// import mockCustomer from 'mock/customer';
import { API_VERSION } from './define';
import { callFetch, callStoreFetch } from './response';
import { authAccessTokenHeader, header } from './settings';

const resource = 'users';

const EndPoint = {
    GetCreateCustomer: (lineId) => `/${API_VERSION}/${resource}/${lineId}`,
    //SmsCode: () => `/${API_VERSION}/${resource}/sms-code`,
    SmsCode: () => `/${API_VERSION}/sms/sms-code`,
    //SmsVerify: () => `/${API_VERSION}/${resource}/sms-verify`
    SmsVerify: () => `/${API_VERSION}/sms/sms-verify`
};

export function getStoreCreateCustomer(data, accessToken) {
    const cli = callStoreFetch(STORE_KEYS.SERVER_CUSTOMER, getStoreCreateCustomer.name);
    const uri = EndPoint.GetCreateCustomer(data.lineId);
    let settings = {
        method: 'POST',
        headers: { ...header },
        body: JSON.stringify({ accessToken })
    };

    return cli(uri, settings);
}

// only for AuthProvider getCreateCustomer
export function getCreateCustomer(data, accessToken) {
    const uri = EndPoint.GetCreateCustomer(data.lineId);
    let settings = {
        method: 'POST',
        headers: { ...authAccessTokenHeader(accessToken) },
        body: JSON.stringify(data)
    };
    // if (configs.STAGE === 'local') return mockCustomer;
    return callFetch(uri, settings);
}

export function sendSms(phoneNumber, accessToken) {
    const uri = EndPoint.SmsCode();
    let settings = {
        method: 'POST',
        headers: { ...authAccessTokenHeader(accessToken) },
        body: JSON.stringify({
            phoneNumber: getMobileNumber(phoneNumber),
            options: {
                hasCharacter: false,
                length: 4,
                verifyCodeMessage: '您好\n您的行動電話 OTP 驗證碼為「{{code}}」，請立即在欄位輸入，完成驗證作業。'
            }
        })
    };

    return callFetch(uri, settings);
}
export function verifySms(lineId, phoneNumber, verifyCode, accessToken) {
    const uri = EndPoint.SmsVerify();
    let settings = {
        method: 'POST',
        headers: { ...authAccessTokenHeader(accessToken) },
        body: JSON.stringify({
            phoneNumber: getMobileNumber(phoneNumber),
            lineId,
            verifyCode
        })
    };

    return callFetch(uri, settings);
}
